import React, { Component } from "react";
import StudentCard from "./StudentCard";

class StudentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      students: [
        { name: "Sumit Kamodkar", rollNo: "101", course: "ReactJS", batch: "12-2 PM" },
        { name: "Ishan Burchunde", rollNo: "102", course: "NodeJS", batch: "12-2 PM" },
        { name: "Saloni Wase", rollNo: "103", course: "Bootstrap", batch: "12 PM" },
        { name: "Alisha ", rollNo: "104", course: "JavaScript", batch: "5-6 PM" }
      ]
    };
  }

  render() {
    return (
      <div className="container my-5" id="students">
        <h2 className="mb-4 text-center fw-bold">📋 Student List</h2>
        <div className="row">
          {this.state.students.map((student, index) => (
            <StudentCard
              key={index}
              name={student.name}
              rollNo={student.rollNo}
              course={student.course}
              batch={student.batch}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default StudentList;
